import { render } from "./SiprComponent.vue?vue&type=template&id=1bd30908&scoped=true"
import script from "./SiprComponent.vue?vue&type=script&lang=js"
export * from "./SiprComponent.vue?vue&type=script&lang=js"

import "./SiprComponent.vue?vue&type=style&index=0&id=1bd30908&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd30908"]])

export default __exports__